export default {
  getXeroPerson: (state) => state.xeroPerson,
};
